module.exports = __webpack_public_path__ + "static/media/face2.7e0e382d.jpg";